export const countries = [
	[
		"af",
		"93"
	],
	[
		"al",
		"355"
	],
	[
		"dz",
		"213"
	],
	[
		"ad",
		"376"
	],
	[
		"ao",
		"244"
	],
	[
		"ag",
		"1268"
	],
	[
		"ar",
		"54",
		"(..) ........"
	],
	[
		"am",
		"374"
	],
	[
		"aw",
		"297"
	],
	[
		"au",
		"61",
		"(..) .... ....",
		0,
		[
			"2",
			"3",
			"4",
			"7",
			"8",
			"02",
			"03",
			"04",
			"07",
			"08"
		]
	],
	[
		"at",
		"43"
	],
	[
		"az",
		"994"
	],
	[
		"bs",
		"1242"
	],
	[
		"bh",
		"973"
	],
	[
		"bd",
		"880"
	],
	[
		"bb",
		"1246"
	],
	[
		"by",
		"375",
		"(..) ... .. .."
	],
	[
		"be",
		"32",
		"... .. .. .."
	],
	[
		"bz",
		"501"
	],
	[
		"bj",
		"229"
	],
	[
		"bt",
		"975"
	],
	[
		"bo",
		"591"
	],
	[
		"ba",
		"387"
	],
	[
		"bw",
		"267"
	],
	[
		"br",
		"55",
		"(..) ........."
	],
	[
		"io",
		"246"
	],
	[
		"bn",
		"673"
	],
	[
		"bg",
		"359"
	],
	[
		"bf",
		"226"
	],
	[
		"bi",
		"257"
	],
	[
		"kh",
		"855"
	],
	[
		"cm",
		"237"
	],
	[
		"ca",
		"1",
		"(...) ...-....",
		1,
		[
			"204",
			"226",
			"236",
			"249",
			"250",
			"289",
			"306",
			"343",
			"365",
			"387",
			"403",
			"416",
			"418",
			"431",
			"437",
			"438",
			"450",
			"506",
			"514",
			"519",
			"548",
			"579",
			"581",
			"587",
			"604",
			"613",
			"639",
			"647",
			"672",
			"705",
			"709",
			"742",
			"778",
			"780",
			"782",
			"807",
			"819",
			"825",
			"867",
			"873",
			"902",
			"905"
		]
	],
	[
		"cv",
		"238"
	],
	[
		"bq",
		"599",
		"",
		1
	],
	[
		"cf",
		"236"
	],
	[
		"td",
		"235"
	],
	[
		"cl",
		"56"
	],
	[
		"cn",
		"86",
		"..-........."
	],
	[
		"co",
		"57"
	],
	[
		"km",
		"269"
	],
	[
		"cd",
		"243"
	],
	[
		"cg",
		"242"
	],
	[
		"cr",
		"506",
		"....-...."
	],
	[
		"ci",
		"225",
		".. .. .. .."
	],
	[
		"hr",
		"385"
	],
	[
		"cu",
		"53"
	],
	[
		"cw",
		"599",
		"",
		0
	],
	[
		"cy",
		"357",
		".. ......"
	],
	[
		"cz",
		"420"
	],
	[
		"dk",
		"45",
		".. .. .. .."
	],
	[
		"dj",
		"253"
	],
	[
		"dm",
		"1767"
	],
	[
		"do",
		"1",
		"",
		2,
		[
			"809",
			"829",
			"849"
		]
	],
	[
		"ec",
		"593"
	],
	[
		"eg",
		"20"
	],
	[
		"sv",
		"503",
		"....-...."
	],
	[
		"gq",
		"240"
	],
	[
		"er",
		"291"
	],
	[
		"ee",
		"372",
		".... ......"
	],
	[
		"et",
		"251"
	],
	[
		"fj",
		"679"
	],
	[
		"fi",
		"358",
		".. ... .. .."
	],
	[
		"fr",
		"33",
		". .. .. .. .."
	],
	[
		"gf",
		"594"
	],
	[
		"pf",
		"689"
	],
	[
		"ga",
		"241"
	],
	[
		"gm",
		"220"
	],
	[
		"ge",
		"995"
	],
	[
		"de",
		"49",
		".... ........"
	],
	[
		"gh",
		"233"
	],
	[
		"gr",
		"30"
	],
	[
		"gd",
		"1473"
	],
	[
		"gp",
		"590",
		"",
		0
	],
	[
		"gu",
		"1671"
	],
	[
		"gt",
		"502",
		"....-...."
	],
	[
		"gn",
		"224"
	],
	[
		"gw",
		"245"
	],
	[
		"gy",
		"592"
	],
	[
		"ht",
		"509",
		"....-...."
	],
	[
		"hn",
		"504"
	],
	[
		"hk",
		"852",
		".... ...."
	],
	[
		"hu",
		"36"
	],
	[
		"is",
		"354",
		"... ...."
	],
	[
		"in",
		"91",
		".....-....."
	],
	[
		"id",
		"62"
	],
	[
		"ir",
		"98"
	],
	[
		"iq",
		"964"
	],
	[
		"ie",
		"353",
		".. ......."
	],
	[
		"il",
		"972",
		"... ... ...."
	],
	[
		"it",
		"39",
		"... .......",
		0
	],
	[
		"jm",
		"1876"
	],
	[
		"jp",
		"81",
		".. .... ...."
	],
	[
		"jo",
		"962"
	],
	[
		"kz",
		"7",
		"... ...-..-..",
		1,
		[
			"310",
			"311",
			"312",
			"313",
			"315",
			"318",
			"321",
			"324",
			"325",
			"326",
			"327",
			"336",
			"7172",
			"73622"
		]
	],
	[
		"ke",
		"254"
	],
	[
		"ki",
		"686"
	],
	[
		"xk",
		"383"
	],
	[
		"kw",
		"965"
	],
	[
		"kg",
		"996"
	],
	[
		"la",
		"856"
	],
	[
		"lv",
		"371"
	],
	[
		"lb",
		"961"
	],
	[
		"ls",
		"266"
	],
	[
		"lr",
		"231"
	],
	[
		"ly",
		"218"
	],
	[
		"li",
		"423"
	],
	[
		"lt",
		"370"
	],
	[
		"lu",
		"352"
	],
	[
		"mo",
		"853"
	],
	[
		"mk",
		"389"
	],
	[
		"mg",
		"261"
	],
	[
		"mw",
		"265"
	],
	[
		"my",
		"60",
		"..-....-...."
	],
	[
		"mv",
		"960"
	],
	[
		"ml",
		"223"
	],
	[
		"mt",
		"356"
	],
	[
		"mh",
		"692"
	],
	[
		"mq",
		"596"
	],
	[
		"mr",
		"222"
	],
	[
		"mu",
		"230"
	],
	[
		"mx",
		"52",
		"... ... ....",
		0,
		[
			"55",
			"81",
			"33",
			"656",
			"664",
			"998",
			"774",
			"229"
		]
	],
	[
		"fm",
		"691"
	],
	[
		"md",
		"373",
		"(..) ..-..-.."
	],
	[
		"mc",
		"377"
	],
	[
		"mn",
		"976"
	],
	[
		"me",
		"382"
	],
	[
		"ma",
		"212"
	],
	[
		"mz",
		"258"
	],
	[
		"mm",
		"95"
	],
	[
		"na",
		"264"
	],
	[
		"nr",
		"674"
	],
	[
		"np",
		"977"
	],
	[
		"nl",
		"31",
		".. ........"
	],
	[
		"nc",
		"687"
	],
	[
		"nz",
		"64",
		"...-...-...."
	],
	[
		"ni",
		"505"
	],
	[
		"ne",
		"227"
	],
	[
		"ng",
		"234"
	],
	[
		"kp",
		"850"
	],
	[
		"no",
		"47",
		"... .. ..."
	],
	[
		"om",
		"968"
	],
	[
		"pk",
		"92",
		"...-......."
	],
	[
		"pw",
		"680"
	],
	[
		"ps",
		"970"
	],
	[
		"pa",
		"507"
	],
	[
		"pg",
		"675"
	],
	[
		"py",
		"595"
	],
	[
		"pe",
		"51"
	],
	[
		"ph",
		"63",
		".... ......."
	],
	[
		"pl",
		"48",
		"...-...-..."
	],
	[
		"pt",
		"351"
	],
	[
		"pr",
		"1",
		"",
		3,
		[
			"787",
			"939"
		]
	],
	[
		"qa",
		"974"
	],
	[
		"re",
		"262"
	],
	[
		"ro",
		"40"
	],
	[
		"ru",
		"7",
		"(...) ...-..-..",
		0
	],
	[
		"rw",
		"250"
	],
	[
		"kn",
		"1869"
	],
	[
		"lc",
		"1758"
	],
	[
		"vc",
		"1784"
	],
	[
		"ws",
		"685"
	],
	[
		"sm",
		"378"
	],
	[
		"st",
		"239"
	],
	[
		"sa",
		"966"
	],
	[
		"sn",
		"221"
	],
	[
		"rs",
		"381"
	],
	[
		"sc",
		"248"
	],
	[
		"sl",
		"232"
	],
	[
		"sg",
		"65",
		"....-...."
	],
	[
		"sk",
		"421"
	],
	[
		"si",
		"386"
	],
	[
		"sb",
		"677"
	],
	[
		"so",
		"252"
	],
	[
		"za",
		"27"
	],
	[
		"kr",
		"82",
		"... .... ...."
	],
	[
		"ss",
		"211"
	],
	[
		"es",
		"34",
		"... ... ..."
	],
	[
		"lk",
		"94"
	],
	[
		"sd",
		"249"
	],
	[
		"sr",
		"597"
	],
	[
		"sz",
		"268"
	],
	[
		"se",
		"46",
		"(...) ...-..."
	],
	[
		"ch",
		"41",
		".. ... .. .."
	],
	[
		"sy",
		"963"
	],
	[
		"tw",
		"886"
	],
	[
		"tj",
		"992"
	],
	[
		"tz",
		"255"
	],
	[
		"th",
		"66"
	],
	[
		"tl",
		"670"
	],
	[
		"tg",
		"228"
	],
	[
		"to",
		"676"
	],
	[
		"tt",
		"1868"
	],
	[
		"tn",
		"216"
	],
	[
		"tr",
		"90",
		"... ... .. .."
	],
	[
		"tm",
		"993"
	],
	[
		"tv",
		"688"
	],
	[
		"ug",
		"256"
	],
	[
		"ua",
		"380",
		"(..) ... .. .."
	],
	[
		"ae",
		"971"
	],
	[
		"gb",
		"44",
		".... ......"
	],
	[
		"us",
		"1",
		"(...) ...-....",
		0,
		[
			"907",
			"205",
			"251",
			"256",
			"334",
			"479",
			"501",
			"870",
			"480",
			"520",
			"602",
			"623",
			"928",
			"209",
			"213",
			"310",
			"323",
			"408",
			"415",
			"510",
			"530",
			"559",
			"562",
			"619",
			"626",
			"650",
			"661",
			"707",
			"714",
			"760",
			"805",
			"818",
			"831",
			"858",
			"909",
			"916",
			"925",
			"949",
			"951",
			"303",
			"719",
			"970",
			"203",
			"860",
			"202",
			"302",
			"239",
			"305",
			"321",
			"352",
			"386",
			"407",
			"561",
			"727",
			"772",
			"813",
			"850",
			"863",
			"904",
			"941",
			"954",
			"229",
			"404",
			"478",
			"706",
			"770",
			"912",
			"808",
			"319",
			"515",
			"563",
			"641",
			"712",
			"208",
			"217",
			"309",
			"312",
			"618",
			"630",
			"708",
			"773",
			"815",
			"847",
			"219",
			"260",
			"317",
			"574",
			"765",
			"812",
			"316",
			"620",
			"785",
			"913",
			"270",
			"502",
			"606",
			"859",
			"225",
			"318",
			"337",
			"504",
			"985",
			"413",
			"508",
			"617",
			"781",
			"978",
			"301",
			"410",
			"207",
			"231",
			"248",
			"269",
			"313",
			"517",
			"586",
			"616",
			"734",
			"810",
			"906",
			"989",
			"218",
			"320",
			"507",
			"612",
			"651",
			"763",
			"952",
			"314",
			"417",
			"573",
			"636",
			"660",
			"816",
			"228",
			"601",
			"662",
			"406",
			"252",
			"336",
			"704",
			"828",
			"910",
			"919",
			"701",
			"308",
			"402",
			"603",
			"201",
			"609",
			"732",
			"856",
			"908",
			"973",
			"505",
			"575",
			"702",
			"775",
			"212",
			"315",
			"516",
			"518",
			"585",
			"607",
			"631",
			"716",
			"718",
			"845",
			"914",
			"216",
			"330",
			"419",
			"440",
			"513",
			"614",
			"740",
			"937",
			"405",
			"580",
			"918",
			"503",
			"541",
			"215",
			"412",
			"570",
			"610",
			"717",
			"724",
			"814",
			"401",
			"803",
			"843",
			"864",
			"605",
			"423",
			"615",
			"731",
			"865",
			"901",
			"931",
			"210",
			"214",
			"254",
			"281",
			"325",
			"361",
			"409",
			"432",
			"512",
			"713",
			"806",
			"817",
			"830",
			"903",
			"915",
			"936",
			"940",
			"956",
			"972",
			"979",
			"435",
			"801",
			"276",
			"434",
			"540",
			"703",
			"757",
			"804",
			"802",
			"206",
			"253",
			"360",
			"425",
			"509",
			"262",
			"414",
			"608",
			"715",
			"920",
			"304",
			"307"
		]
	],
	[
		"uy",
		"598"
	],
	[
		"uz",
		"998"
	],
	[
		"vu",
		"678"
	],
	[
		"va",
		"39",
		".. .... ....",
		1
	],
	[
		"ve",
		"58"
	],
	[
		"vn",
		"84"
	],
	[
		"ye",
		"967"
	],
	[
		"zm",
		"260"
	],
	[
		"zw",
		"263"
	]
];
